module.exports = __webpack_public_path__ + "img/youtube_social_icon_red.57c75406.png";